import { EarningsView, formatCurrency, formatNumber } from "../../../pages/Restaurants/Finance/data";
import Modal, { ModalContent } from "../../elements/Modal";

const FinancialDetails = ({
  earningDetails,
  toggleModal,
}: {
  earningDetails: EarningsView;
  toggleModal: () => void;
}) => {
  return (
    <Modal
      open={true}
      onClose={toggleModal}
      className="flex items-center justify-center"
    >
      <ModalContent className="mx-3 p-6 rounded-md shadow-lg flex flex-col  bg-white w-[80%] md:w-[45%] lg:w-[40%] xl:w-[50%] font-mont">
        <h1 className="font-semibold text-2xl text-secondary pb-3">
          {earningDetails?.name} - Financial Details
        </h1>
        <p className="text-gray-500">
          Complete financial overview and payout management
        </p>

        <section className="flex justify-between items-center gap-3 my-3">
          <article className="border p-2 rounded-md w-[216px]">
            <h3 className="text-sm">Total Earnings</h3>
            <p className="text-lg font-semibold">
              {formatCurrency(earningDetails?.totalEarnings || 0)}
            </p>
          </article>
          <article className="border p-2 rounded-md w-[216px]">
            <h3 className="text-sm">Pending Payouts</h3>
            <p className="text-lg font-semibold">
              {formatCurrency(earningDetails?.pendingPayouts || 0)}
            </p>
          </article>
          <article className="border p-2 rounded-md w-[216px]">
            <h3 className="text-sm">Last Payout</h3>
            <p className="text-lg font-semibold">
              {formatCurrency(earningDetails?.lastPayout || 0)}
            </p>
          </article>
          <article className="border p-2 rounded-md w-[216px]">
            <h3 className="text-sm">Weekly Growth</h3>
            <p className="text-lg font-semibold">
              {earningDetails?.weeklyGrowth}
            </p>
          </article>
        </section>
        <section>
          <h3 className="text-lg font-semibold mt-3 mb-2">
            Payout Information
          </h3>
          <article className="flex justify-between items-center gap-3 w-2/3 my-1">
            <span>Commission Rate:</span>
            <p className="w-1/2">{earningDetails?.commissionRate}%</p>
          </article>
          <article className="flex justify-between items-center gap-3 w-2/3 my-1">
            <span>Next Payout:</span>
            <p className="w-1/2">{earningDetails?.nextPayout}</p>
          </article>
          <article className="flex justify-between items-center gap-3 w-2/3 my-1">
            <span>Total Orders:</span>
            <p className="w-1/2">{formatNumber(earningDetails?.totalOrders || 0)}</p>
          </article>
          <article className="flex justify-between items-center gap-3 w-2/3 my-1">
            <span>Status:</span>
            <p className="w-1/2 text-secondary capitalize">
              {earningDetails?.status}
            </p>
          </article>
        </section>
        <section className="w-full flex justify-center">
          <button
            type="button"
            className="mt-4 bg-secondary w-1/2 text-white py-2 px-4 rounded-md"
          >
            Process Payment
          </button>
        </section>
      </ModalContent>
    </Modal>
  );
};

export default FinancialDetails;
